import { useOnlineStatus } from '@/pwa/use-online-status'

export function OfflineBanner() {
  const online = useOnlineStatus()
  if (online) return null

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] text-center py-1 text-xs font-mono tracking-wide"
      style={{ backgroundColor: 'rgba(245, 158, 11, 0.15)', color: '#F59E0B' }}
    >
      You're offline — showing cached data
    </div>
  )
}
